<template>
    <emapm-upload-imgs :host="host" :label="model.caption" :host-pathname="hostPathname" :read-only="param.readonly || param.disabled" :required="param.required" :token="value" :size="4000" :max-number="maxNumber" @on-token-change="onTokenChange" class="emapm-uploa-imgs" :titlewidth="titlewidth" :value-align="textalign" :file-name="fileName" ref="upload"></emapm-upload-imgs>
</template>
<script>
import emapmUploadImgs from 'components/emapm-upload-imgs.vue';
export default {

    name: 'emUploadImage',

    props: {
        model: {
            type: Object,
            default: function() {
                return {};
            }
        },
        value: {
            type: String,
            default: function() {
                return '';
            }
        },
        titlewidth:{
            type: String,
            default: function() {
                return '';
            }
        },
        textalign:{
            type: String,
            default: function() {
                return '';//flex-start
            }
        }
    },

    data() {
        return {
            host: location.origin,
            hostPathname: location.origin + location.pathname.substring(0, location.pathname.indexOf("/", 1))
        };
    },

    computed: {
        param() {
            return this.model.initParam;
        },
        maxNumber() {
            if (this.model.xtype === 'uploadsingleimage') {
                return 1;
            }
            if (this.param.limit) {
                return this.param.limit;
            }
            return 9;
        },
        fileName() {
            return this.param.fileName;
        }
    },

    methods: {
        onTokenChange(val) {
            this.$emit('input', val);
        },
        getImageUrls() {
            return this.$refs.upload.previewUrl;
        }
    },

    components: {
        emapmUploadImgs
    }
};
</script>
<style lang="css" scoped>
.emapm-upload-imgs {
    padding-bottom: 0px;
}
</style>


// WEBPACK FOOTER //
// emUploadImage.vue?72eb327a